import { app } from '../../../app';
import { Controller } from './connectors.controller';

app.component('userConnectors', {
    bindings: {
        account: '<',
        connectors: '<',
    },
    controller: Controller,
    templateUrl: require('./connectors.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/connectors/connectors.component.js